module.exports = __webpack_public_path__ + "img/db.46343b1b.png";